// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_f0-a";
export var fulfillmentFormRail = "_f0-9";
export var headerTitleRow = "_f0-c";
export var orderDetailsWrapper = "_f0-7";
export var orderLinkTrigger = "_f0-2";
export var paymentInformationGrid = "_f0-h";
export var paymentSummaryColumn = "_f0-i";
export var shipmentContainer = "_f0-b";
export var shipmentDetailsMainPane = "_f0-8";
export var shipmentNavigationCard = "_f0-5";
export var shipmentNavigationRail = "_f0-3";
export var shipmentNavigationRailHeader = "_f0-4";
export var shipmentSummaryFact = "_f0-e";
export var shipmentSummaryGrid = "_f0-d";
export var shipmentSummaryMetadataRow = "_f0-f";
export var shipmentSummaryTags = "_f0-g";
export var shipmentWorkspace = "_f0-0";
export var shipmentWorkspaceContent = "_f0-6";
export var shipmentWorkspaceHeader = "_f0-1";